import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const PageBanner = ({ title, crumb }) => (
  <section className="relative py-20 md:py-28 bg-cover bg-center"
    style={{ backgroundImage: 'linear-gradient(rgba(15,21,40,0.7), rgba(15,21,40,0.7)), url(https://images.unsplash.com/photo-1543689604-6fe8dbcd1f59?auto=format&fit=crop&w=1920&q=80)' }}>
    <div className="max-w-[1200px] mx-auto px-6 text-center text-white">
      <h1 className="heading-display text-4xl md:text-6xl font-bold">{title}</h1>
      <div className="mt-4 flex items-center justify-center gap-2 text-sm md:text-base text-white/90">
        <Link to="/" className="inline-flex items-center gap-1.5 hover:text-[#F97559] transition-colors"><Home size={14} /> Home</Link>
        <span className="text-white/50">/</span>
        <span className="text-[#F97559]">{crumb || title}</span>
      </div>
    </div>
  </section>
);

export default PageBanner;
